export default __webpack_public_path__ + "static/media/pricing-image.579ac104.svg";